import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { theme as defaultTheme } from '@miro-site/design-tokens';
var colors = {
  secondary4: 'var(--wcds-colors-gray-30)',
  secondary8: 'var(--wcds-colors-indigo-20)',
  secondary20: 'var(--wcds-colors-indigo-30)',
  secondary40: 'var(--wcds-colors-indigo-50)',
  secondary60: 'var(--wcds-colors-indigo-50)',
  gray: 'var(--wcds-colors-indigo-50)'
};
var templates = {
  buttons: {
    transparent: {
      color: defaultTheme.colors.primaryIndigo,
      border: "1px solid var(--deprecated-transparent-link-border-color)",
      background: 'var(--deprecated-transparent-link-background-color)',
      ':hover': {
        borderColor: 'transparent',
        color: defaultTheme.colors.primaryWhite,
        background: defaultTheme.colors.primaryBlueHover
      },
      ':focus': _objectSpread({}, defaultTheme.focus.outlines["default"])
    }
  },
  colors: colors,
  elevation: {
    overlay: '2px 4px 16px rgba(var(--wcds-colors-black-rgb), 0.1)',
    topBar: '0px 4px 12px rgba(var(--wcds-colors-indigo-90-rgb), 0.07)',
    fixedSearch: '0px 4px 12px rgba(var(--wcds-colors-indigo-90-rgb), 0.12)'
  }
};
var miroverseHighlighted = {
  container: {
    verticalPadding: 20,
    horizontalPadding: 20,
    radius: 10,
    background: colors.secondary4
  },
  title: {
    as: 'h4',
    variant: 'p2',
    fontWeight: 500,
    color: 'primaryIndigo',
    margins: {
      afterTitle: [null, 12]
    }
  },
  itemContainer: {
    verticalPadding: 15,
    link: {
      dividerColor: 'lightGray'
    },
    itemTitle: {
      fontSize: 14,
      lineHeight: 18,
      color: 'primaryIndigo'
    },
    itemDescription: {
      fontSize: 12,
      lineHeight: 20,
      color: colors.gray
    },
    imageWidth: '100%',
    margins: {
      afterImage: '5%'
    }
  },
  actionLink: {
    variant: 'regular',
    color: 'default',
    size: 'default',
    withArrow: true,
    fontSize: 14,
    fontWeight: 400,
    margins: {
      beforeLink: 15
    }
  }
};

var theme = _objectSpread(_objectSpread({}, defaultTheme), {}, {
  layout: {
    /**
     * Increasing the container width to match the width of
     * the new web core design system header
     */
    defaultContainerWidth: 1150
  },
  templates: templates,
  miroverseHighlighted: miroverseHighlighted
});

export default theme;